import { CreateMeasureBuffer } from "./CreateMeasureBuffer";
import { SetCtxFont } from "./SetCtxFont";
import { Globals } from "../CoreApp/Globals";

export function MeasureText(theText, fontString) {
  CreateMeasureBuffer();

  var ctx = Globals._measureBuffer.getContext("2d");

  SetCtxFont(ctx, fontString);
  var txtDim = ctx.measureText(theText);
  var lengthInPixels = Math.ceil(txtDim.width);
  return lengthInPixels;
}
